export default __webpack_public_path__ + "static/media/parking.d19efb6c.svg";